import { create } from "zustand";

interface FileComparisonStore {
  sessionId: string;
  conversationId: string;
  status: string;
  uploadErrors: string;
  setUploadErrors: (erorr: string) => void;
  setStatus: (status: string) => void;
  setSessionId: (uuid: string) => void;
  setConversationId: (convId: string) => void;
}

const useFileComparisonStore = create<FileComparisonStore>((set) => ({
  sessionId: "",
  conversationId: "",
  status: "START",
  uploadErrors: "",
  setUploadErrors: (errors: string) => {
    set({ uploadErrors: errors });
  },
  setStatus: (status: string) => {
    set({ status: status });
  },
  setSessionId: (uuid: string) => {
    set({ sessionId: uuid });
  },
  setConversationId: (convId: string) => {
    set({ conversationId: convId });
  },
}));

export default useFileComparisonStore;
